var _excluded = ["property"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import AllhomesListingWhatsNearby from './allhomes-listing-whats-nearby';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingWhatsNearby on Property {\n    address {\n      nearbyPOIs {\n        name\n        type\n        distance\n      }\n    }\n  }\n"])));
var POI_TYPE = {
  PRIMARY_SCHOOL: {
    label: 'Primary School',
    iconName: 'school'
  },
  HIGH_SCHOOL: {
    label: 'High School',
    iconName: 'school'
  },
  COLLEGE: {
    label: 'College',
    iconName: 'school'
  },
  TAFE: {
    label: 'Tafe',
    iconName: 'school'
  },
  UNIVERSITY: {
    label: 'University',
    iconName: 'school'
  },
  HOSPITAL: {
    label: 'Hospital',
    iconName: 'hospital'
  },
  POST_OFFICE: {
    label: 'Post Office',
    iconName: 'email'
  },
  SHOPPING_CENTRE: {
    label: 'Major Shopping Centre',
    iconName: 'supermarket'
  },
  DEFAULT: {
    label: 'Point of Interest',
    iconName: 'pin'
  }
};
var poiType = poi => POI_TYPE[poi.type] || POI_TYPE.DEFAULT;
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$address = _ref.address,
    address = _ref$address === void 0 ? {} : _ref$address;
  return {
    items: address.nearbyPOIs.map(poi => ({
      name: poi.name,
      distance: poi.distance,
      type: poiType(poi).label,
      iconName: poiType(poi).iconName
    }))
  };
};
var AllhomesListingWhatsNearbyGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(AllhomesListingWhatsNearby, _extends({}, graphQLToProps(property), props));
};
AllhomesListingWhatsNearbyGraphQL.fragment = fragment;
AllhomesListingWhatsNearbyGraphQL.propTypes = {
  property: PropTypes.shape({
    address: PropTypes.shape({
      nearbyPOIs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.string,
        distance: PropTypes.number
      }))
    })
  })
};
AllhomesListingWhatsNearbyGraphQL.defaultProps = {
  property: {}
};
export default AllhomesListingWhatsNearbyGraphQL;